module.exports = __webpack_public_path__ + "media/assets/images/book-blue-c42e157f34c9a233357e822b858f4682.svg";